export default {
  'en': {
    'days': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    'months': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    'pickers': ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
    'placeholder': {
      'date': 'Select Date',
      'dateRange': 'Select Date Range'
    }
  },
  'ru': {
    'days': ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    'months': ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    'pickers': ['след. 7 дней', 'след. 30 дней', 'прош. 7 дней', 'прош. 30 дней'],
    'placeholder': {
      'date': 'Выберите дату',
      'dateRange': 'Выберите период'
    }
  },
  'kk': {
    'days': ['Жексенбі', 'Дүйсенбі', 'Сейсенбі', 'Сәрсенбі', 'Четоверг', 'Жұма', 'Сенбі'],
    'months': ['Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым', 'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Қараша'],
    'pickers': ['келесі 7 күн ', 'келесі 30 күн', 'өткен 7 күн', 'өткен 30 күн'],
    'placeholder': {
      'date': 'Күнді таңдаңыз',
      'dateRange': 'Кезеңді таңдаңыз'
    }
  },
  'az': {
    'days': ['günəş', 'bazar', 'cərşənbə', 'cərşənbə', 'cərşənbə', 'сümə', 'sənbə'],
    'months': ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun', 'Iyul', 'Avqust', 'Sentyabr', 'Oktyabr', 'Noyabr', 'Dekabr'],
    'pickers': ['Növbəti 7 gün', 'Növbəti 30 gün', 'Son 7 gün', 'Son 30 gün'],
    'placeholder': {
      'date': 'Tarix seçin',
      'dateRange': 'Dövr seçin'
    }
  },
  'ka': {
    'days': ['Արև', 'Երկուշաբթի', 'Երեք', 'Չորք', 'Հինգ', 'Ուրբաթ', 'Շաբաթ'],
    'months': ['Յան', 'Փետրվար', 'Մար', 'Ապրիլ', 'Մայիս', 'Հունիս', 'Հուլիս', 'Օգոստոս', 'Սեպ', 'Հոկտեմբեր', 'Նոյ', 'Դեկ'],
    'pickers': ['հետևել. 7 օր', 'հաջորդ. 30 օր', 'անցյալ. 7 օր', 'անցյալ. 30 օր'],
    'placeholder': {
      'date': 'Ընտրել ամսաթիվ',
      'dateRange': 'Ընտրել ժամանակաշրջան'
    }
  }
}
